var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_834_2503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 10.0002H2.66667C2.31305 10.0002 1.97391 9.85969 1.72386 9.60964C1.47381 9.35959 1.33333 9.02045 1.33333 8.66683V2.66683C1.33333 2.31321 1.47381 1.97407 1.72386 1.72402C1.97391 1.47397 2.31305 1.3335 2.66667 1.3335H8.66667C9.02029 1.3335 9.35943 1.47397 9.60948 1.72402C9.85952 1.97407 10 2.31321 10 2.66683V3.3335M7.33333 6.00016H13.3333C14.0697 6.00016 14.6667 6.59712 14.6667 7.3335V13.3335C14.6667 14.0699 14.0697 14.6668 13.3333 14.6668H7.33333C6.59695 14.6668 6 14.0699 6 13.3335V7.3335C6 6.59712 6.59695 6.00016 7.33333 6.00016Z",
    stroke: "#185CFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_834_2503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.aa339e702b5e7f7765ec02ce1f76c97f.svg";
export { ForwardRef as ReactComponent };